export enum AlterationsTypeKeys {
  SET_ALTERATIONS_MODAL_OPEN = 'SET_ALTERATIONS_MODAL_OPEN'
}

export interface ISetIsAlterationsModalOpenAction {
  type: typeof AlterationsTypeKeys.SET_ALTERATIONS_MODAL_OPEN
  payload: boolean
  [extraProps: string]: unknown
}

export type AlterationsActionTypes =
  | ISetIsAlterationsModalOpenAction
